module.exports = __webpack_public_path__ + "static/media/user.0b9dd6de.svg";